import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import './AboutPage.css';

const AboutPage = () => {
  return (
    <div className="about-page">
      <Header 
        pageClass="about-header"
        rightButton={
          <Link to="/" className="nav-link contact-btn">
            Back to Home
          </Link>
        }
      />
      
      <main className="about-content">
        <div className="about-container">
          <h1>Get in Touch</h1>
          <form className="contact-form">
            <div className="form-group">
              <input 
                type="text" 
                placeholder="Subject" 
                className="form-input"
                required
              />
            </div>
            <div className="form-group">
              <textarea 
                placeholder="Your message..." 
                className="form-textarea"
                rows="6"
                required
              ></textarea>
            </div>
            <button type="submit" className="send-button">
              Send Message
            </button>
          </form>
          <div className="email-direct-option">
            <p>Or email us directly:</p>
            <a href="mailto:contact@sparklabs.com" className="email-direct-link">
              contact@sparklabs.com
            </a>
          </div>
        </div>
      </main>
      <footer className="footer-banner">
        <div className="footer-content">
          <p>&copy; 2025 SparkLabs LLC. All rights reserved.</p>
        </div>
      </footer>
    </div>

  );
};

export default AboutPage;
